import {
  Avatar,
  Button,
  Card,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { AddOutlined, InfoOutlined, MoreHoriz } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import ScrollBar from "react-perfect-scrollbar";
import Swal from "sweetalert2";

import { MatxMenu } from "../../../../../matx";
import { ModalMisi, UploadImage } from "../../../../components";
import {
  getVisiMisiData,
  updVisiMisiData,
} from "../../../../redux/actions/VisiMisiActions";

const Vismis = () => {
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMisi, setShowMisi] = useState(false);
  const [mission, setMission] = useState(null);
  const [params, setParams] = useState({
    title_id: "",
    title_en: "",
    desc_id: "",
    desc_en: "",
    bg_img: "",
    bg_img_ori: "",
    bg_img_preview: "",
    mission: [],
  });
  const handleChange = ({ target: { value, name } }, index = 0) => {
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updVisiMisiData(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = () => {
    setLoading(true);
    getVisiMisiData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            ...data,
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const handleChangeFoto = (file, path) => {
    setParams((pref) => ({
      ...pref,
      bg_img: file,
      bg_img_preview: path,
    }));
  };

  const handleSaveMisi = (data) => {
    if (data?.idx) {
      let cek = params.mission.findIndex((item) => item.idx === data.idx);
      let misi = params.mission;
      misi[cek].icon = data?.icon ? data.icon : misi[cek].icon;
      misi[cek].title_id = data.title_id;
      misi[cek].title_en = data.title_en;
      misi[cek].desc_id = data.desc_id;
      misi[cek].desc_en = data.desc_en;
      setParams((pref) => ({
        ...pref,
        mission: [...misi],
      }));
      setShowMisi(false);
      setMission(null);
    } else {
      let newMisi = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        mission: [...pref.mission, newMisi],
      }));
      setShowMisi(false);
      setMission(null);
    }
  };

  const handleDelMisi = (idx) => {
    let newMission = params.mission.filter((item) => item.idx === idx);
    setParams((pref) => ({
      ...pref,
      mission: newMission,
    }));
  };

  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Sejarah Perusahaan - Visi & Misi</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="p-5">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <h4 className="fw-bold mb-5 mt-10">Visi</h4>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="desc_id" className="mb-4">
                      Deskripsi [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="desc_id"
                      placeholder="Deskripsi"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="desc_id"
                      value={params.desc_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Deskripsi terlebih dahulu"]}
                      multiline
                      maxRows={16}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="desc_en" className="mb-4">
                      Deskripsi [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="desc_en"
                      placeholder="deskripsi"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="desc_en"
                      value={params.desc_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan deskripsi terlebih dahulu"]}
                      multiline
                      maxRows={16}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h4 className="fw-bold mt-10">Misi</h4>
                  </Grid>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={(file, path) => handleChangeFoto(file, path)}
                      label="Unggah Latar Foto"
                      preview={params.bg_img_preview}
                      required={true}
                      noCrop
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 1440 x 943",
                      ]}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={8} md={10} className="flex items-center">
                    <h5 className="font-semibold">Data Misi</h5>
                  </Grid>
                  <Grid item xs={4} md={2}>
                    <Hidden xsDown>
                      <Button
                        onClick={() => setShowMisi(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                      >
                        <AddOutlined />
                        Tambah
                      </Button>
                    </Hidden>
                    <Hidden smUp>
                      <Button
                        onClick={() => setShowMisi(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                        size="small"
                      >
                        <AddOutlined />
                      </Button>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12}>
                    <ScrollBar className="flex-grow flex-column relative h-full">
                      <Table className="whitespace-pre min-w-750">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" className="w-90 border-b">
                              No
                            </TableCell>
                            <TableCell className="border-b">Judul</TableCell>
                            <TableCell className="border-b">
                              Deskripsi
                            </TableCell>
                            <TableCell className="border-b w-90" align="center">
                              Aksi
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {params.mission?.length <= 0 ? (
                            <TableRow hover>
                              <TableCell
                                className="px-0"
                                align="center"
                                colSpan={4}
                              >
                                Data kosong.
                              </TableCell>
                            </TableRow>
                          ) : (
                            params.mission?.map((item, i) => (
                              <TableRow hover key={item.idx}>
                                <TableCell className="px-0" align="center">
                                  {i + 1}
                                </TableCell>
                                <TableCell className="px-0">
                                  <div className="flex items-center gap-2">
                                    <Avatar
                                      className={item.title_id}
                                      src={item.icon}
                                    />
                                    <span className="text-elipse">
                                      {item.title_id}
                                    </span>
                                  </div>
                                </TableCell>
                                <TableCell className="px-0">
                                  <span
                                    className="text-elipse w-full d-block"
                                    title={item.desc_id}
                                  >
                                    {item.desc_id}
                                  </span>
                                </TableCell>
                                <TableCell className="px-0" align="center">
                                  <MatxMenu
                                    menuButton={
                                      <div className="flex items-center">
                                        <IconButton size="small">
                                          <MoreHoriz />
                                        </IconButton>
                                      </div>
                                    }
                                    horizontalPosition="right"
                                  >
                                    <MenuItem
                                      onClick={() => {
                                        setShowMisi(true);
                                        setMission(item);
                                      }}
                                      className="popup-menu-item"
                                    >
                                      <img
                                        src="/assets/images/icons/ic_action_edit.svg"
                                        alt="icon edit"
                                      />
                                      <span className="pl-4"> Edit </span>
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => handleDelMisi(item.idx)}
                                      className="popup-menu-item"
                                    >
                                      <img
                                        src="/assets/images/icons/ic_action_delete.svg"
                                        alt="icon hapus"
                                      />
                                      <span className="pl-4"> Hapus </span>
                                    </MenuItem>
                                  </MatxMenu>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </ScrollBar>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    className="flex-column-reverse flex-md-row mt-20"
                  >
                    <Grid item xs={12} md={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="text-white w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                      >
                        {submit ? (
                          <CircularProgress color="primary" size={25} />
                        ) : (
                          "Simpan Data"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>

      <ModalMisi
        open={showMisi}
        data={mission}
        handleClose={() => {
          setMission(null);
          setShowMisi(false);
        }}
        handleSave={handleSaveMisi}
      />
    </div>
  );
};

export default Vismis;
